import * as XLSX from 'xlsx'

/**
 * Export data to Excel (.xlsx) in a simple flat table format.
 * This exports raw data for manual analysis, NOT the visual design format.
 */
export function exportToExcel(
  data: Record<string, unknown>[],
  filename: string,
  sheetName = 'Sheet1'
) {
  if (data.length === 0) return

  // Create workbook and worksheet from JSON
  const ws = XLSX.utils.json_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, sheetName)

  // Auto-size columns
  const cols = Object.keys(data[0])
  ws['!cols'] = cols.map((key) => {
    const maxLen = Math.max(
      key.length,
      ...data.map((row) => String(row[key] ?? '').length)
    )
    return { wch: Math.min(maxLen + 2, 40) }
  })

  // Download
  XLSX.writeFile(wb, `${filename}.xlsx`)
}

/**
 * Export multiple sheets to a single Excel file.
 */
export function exportMultiSheet(
  sheets: { name: string; data: Record<string, unknown>[] }[],
  filename: string
) {
  const wb = XLSX.utils.book_new()

  for (const sheet of sheets) {
    if (sheet.data.length === 0) continue
    const ws = XLSX.utils.json_to_sheet(sheet.data)
    const cols = Object.keys(sheet.data[0])
    ws['!cols'] = cols.map((key) => {
      const maxLen = Math.max(
        key.length,
        ...sheet.data.map((row) => String(row[key] ?? '').length)
      )
      return { wch: Math.min(maxLen + 2, 40) }
    })
    XLSX.utils.book_append_sheet(wb, ws, sheet.name.slice(0, 31)) // Excel sheet name max 31 chars
  }

  XLSX.writeFile(wb, `${filename}.xlsx`)
}

/**
 * Export button component style — call this to get consistent styling
 */
export const exportBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.375rem',
  fontSize: '0.6875rem',
} as const
